import React from "react";
import Testimonial from "../../../components/v2/mw-carousel/testimonial";
import AgentIntegration from "../../../components/v2/agent-integration";
import Accordion from "../../../components/v2/accordion/accordion";
import ProductResources from "../../../components/v2/product/product-resource";
import ProductHeroSection from "../../../components/v2/common/product-hero";
import FeaturesMonitoring from "../../../components/v2/tabs/features-monitoring";
import ProductTour from "../../../components/v2/product/product-tour";
import {Docker, K8s, Linux, Windows} from "../../../components/v2/icons";
import { useTranslation } from "next-i18next";
import '../../../styles/scss/_faq-section.module.scss';

export default function RumSessionReplay() {

    const { t } = useTranslation("common", { keyPrefix: "product.rum-session-replay" });

    const heroTitle = (
        <h1>
            <span className={"text-gradient"}>{t("hero.highlight")}</span>
            {t("hero.title")}
        </h1>
    );

    const featuresTitle = (
        <h2>
            {t("featuresSection.prefix")}
            <span className={"text-gradient"}>{t("featuresSection.highlight")}</span>
            {t("featuresSection.suffix")}
        </h2>
    );

    const features = [
        {
            id: "in-depth-insights",
            heading: t("features.inDepth.heading"),
            image: "/images/product/in-depth-insights.png",
            title: t("features.inDepth.title"),
            list: [
                t("features.inDepth.list.0"),
                t("features.inDepth.list.1"),
                t("features.inDepth.list.2")
            ],
            imageAlt: t("features.inDepth.imageAlt")
        },
        {
            id: "replays",
            heading: t("features.replays.heading"),
            image: "/images/product/replays-for-troubleshooting.png",
            title: t("features.replays.title"),
            list: [
                t("features.replays.list.0"),
                t("features.replays.list.1"),
                t("features.replays.list.2")
            ],
            imageAlt: t("features.replays.imageAlt")
        },
        {
            id: "optimisation",
            heading: t("features.optimisation.heading"),
            image: "/images/product/faster-troubleshooting-optimization.png",
            title: t("features.optimisation.title"),
            list: [
                t("features.optimisation.list.0"),
                t("features.optimisation.list.1"),
                t("features.optimisation.list.2")
            ],
            imageAlt: t("features.optimisation.imageAlt")
        },
        {
            id: "interlinked-connections",
            heading: t("features.interlinked.heading"),
            image: "/images/product/connect-back-end-traces-to-user-sessions.png",
            title: t("features.interlinked.title"),
            list: [
                t("features.interlinked.list.0"),
                t("features.interlinked.list.1"),
                t("features.interlinked.list.2")
            ],
            imageAlt: t("features.interlinked.imageAlt")
        },
        {
            id: "root-analysis",
            heading: t("features.root.heading"),
            image: "/images/product/root-cause-analysis.png",
            title: t("features.root.title"),
            list: [
                t("features.root.list.0"),
                t("features.root.list.1"),
                t("features.root.list.2")
            ],
            imageAlt: t("features.root.imageAlt")
        },
        {
            id: "session-inspector",
            heading: t("features.sessionInspector.heading"),
            image: "/images/product/session-inspector.webp",
            title: t("features.sessionInspector.title"),
            list: [
                t("features.sessionInspector.list.0"),
                t("features.sessionInspector.list.1"),
                t("features.sessionInspector.list.2")
            ],
            imageAlt: t("features.sessionInspector.imageAlt")
        }
    ]

    const resource = [
        {
            category: t("resources.items.0.category"),
            title: t("resources.items.0.title"),
            link: "/blog/session-replays/"
        },
        {
            category: t("resources.items.1.category"),
            title: t("resources.items.1.title"),
            link: "/whitepaper/full-stack-observability-modernize-complex-cloud-environments/"
        },
    ]

    const faqs = [
        {
            id: 1,
            header: t("faq.items.0.question"),
            text: <p>{t("faq.items.0.answer")}</p>
        },
        {
            id: 2,
            header: t("faq.items.1.question"),
            text: <p>{t("faq.items.1.answer")}</p>
        },
        {
            id: 3,
            header: t("faq.items.2.question"),
            text: <p>{t("faq.items.2.answer")}</p>
        },
        {
            id: 4,
            header: t("faq.items.3.question"),
            text: <p>{t("faq.items.3.answer")}</p>
        },
        {
            id: 5,
            header: t("faq.items.4.question"),
            text: <p>{t("faq.items.4.answer")}</p>
        },
        {
            id: 6,
            header: t("faq.items.5.question"),
            text: <p>{t("faq.items.5.answer")}</p>
        }
    ];

    const agentDeployData = t("product.shared.agentDeploy", { returnObjects: true }) as any[];
    const agentDeployArray = Array.isArray(agentDeployData) ? agentDeployData : [];
    const agentDeploy = agentDeployArray.map(agent => ({
        ...agent,
        icon: agent.key === 'kubernetes' ? <K8s/> :
              agent.key === 'linux' ? <Linux/> :
              agent.key === 'docker' ? <Docker/> :
              agent.key === 'windows' ? <Windows/> :
              <span className={"text-gradient"}>450+</span>
    }))

    return (
        <>
            <ProductHeroSection title={heroTitle}
                                description={t("hero.description")}
                                img={"/images/product/rum-session-replays.png"} imgMobile={"/images/product/rum-session-replays-mobile.webp"} imgAlt={t("hero.imageAlt")} preloadImg hasActions={true} className={"rum-monitoring"}/>

            <FeaturesMonitoring productFeatures={features} title={featuresTitle} tourId={"rum-session-tour"}/>

            <Testimonial/>

            <ProductTour tourSrc={"https://app.supademo.com/embed/clzmrck0w000ubk4jpfktujuh?embed_v=2"} title={t("tour.title")} tourId={"rum-session-tour"} description={t("tour.description")}/>

            <AgentIntegration agentDeploy={agentDeploy}/>

            <ProductResources resources={resource} title={t("resources.title")}/>

            <section className={"faq-section"}>
                <div className={"container"}>
                    <h2>{t("faq.title")}</h2>
                    <p>{t("faq.description")}</p>
                    <div className={"faq-item"}>
                        <Accordion faqs={faqs} showGroups={true}/>
                    </div>
                </div>
            </section>

        </>
    )
}